module.exports = __webpack_public_path__ + "static/img/bofang.8765b65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/bofang.png
// module id = 2tL5
// module chunks = 24